import { useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Check, Phone, MessageCircle, Mail, ArrowRight } from "lucide-react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";
import { Reveal, Eyebrow } from "../components/Reveal";
import FestivalBanner from "../components/FestivalBanner";
import { SITE } from "../data/site";

export const HI_QUESTIONS = [
    "आप क्या बेच रहे हैं?",
    "उसे कौन ख़रीदे?",
    "ग्राहक आपको ही क्यों चुने?",
    "आपके ग्राहक कहाँ छूट रहे हैं?",
    "आपके बिज़नेस की ग्रोथ क्या रोक रही है?",
];

export const HI_SERVICES = [
    { num: "01", title: "ब्रांड स्ट्रैटेजी", text: "बिज़नेस लक्ष्य के अनुसार पोज़िशनिंग, कम्युनिकेशन और ब्रांड-बिल्डिंग।" },
    { num: "02", title: "रिटेल और ट्रेड मार्केटिंग", text: "रिटेल विज़िबिलिटी, डीलर/डिस्ट्रीब्यूटर एक्टिवेशन और मार्केट एक्ज़ीक्यूशन।" },
    { num: "03", title: "डिजिटल ग्रोथ", text: "सोशल मीडिया, वेबसाइट, कंटेंट, Google और Meta कैंपेन और डिजिटल स्ट्रैटेजी।" },
    { num: "04", title: "कस्टमर एक्विज़िशन", text: "हाइपरलोकल कैंपेन, लीड जनरेशन और ग्राहक बढ़ाने की रणनीतियां।" },
    { num: "05", title: "सेल्स ग्रोथ", text: "enquiries, ग्राहकों और कन्वर्ज़न पर केंद्रित मार्केटिंग — दिखावटी आंकड़े नहीं।" },
];

export const HI_DONT = [
    "सिर्फ़ \u201Cऐक्टिव दिखने\u201D के लिए रैंडम पोस्टिंग नहीं।",
    "कॉपी-पेस्ट मार्केटिंग पैकेज नहीं।",
    "बिज़नेस असर के बिना दिखावटी आंकड़े नहीं।",
    "सबके लिए एक जैसी स्ट्रैटेजी नहीं।",
    "ऐसे प्लान नहीं जो एक्सेल फ़ाइल में भूल जाएँ।",
];

export const HI_DO = [
    "बिज़नेस को समझते हैं।",
    "बाज़ार को समझते हैं।",
    "ग्रोथ का मौका पहचानते हैं।",
    "स्ट्रैटेजी बनाते हैं।",
    "कैंपेन चलाते हैं।",
    "ज़रूरी चीज़ें मापते हैं।",
    "लगातार सुधारते हैं।",
];

export const HI_MARKETS = [
    "दिल्ली", "भोपाल", "इंदौर", "नर्मदापुरम", "इतारसी", "जबलपुर",
    "पिपरिया", "सोहागपुर", "सिवनी मालवा", "बानखेड़ी", "बाबई", "और आसपास के इलाके",
];

export const HI_PROCESS = [
    { num: "01", title: "समझें", text: "हम आपके बिज़नेस, ग्राहक, बाज़ार और मौजूदा चुनौतियों को समझते हैं।" },
    { num: "02", title: "जाँचें", text: "हम देखते हैं कि मार्केटिंग और सेल्स के रास्ते में मौके कहाँ छूट रहे हैं।" },
    { num: "03", title: "बनाएँ", text: "हम स्ट्रैटेजी, कैंपेन, कम्युनिकेशन और एक्ज़ीक्यूशन प्लान तैयार करते हैं।" },
    { num: "04", title: "बढ़ाएँ", text: "हम मापते हैं, सीखते हैं और जो काम करता है उसे बढ़ाते हैं।" },
];

export const HI_FAQS = [
    {
        q: "ALBL Communications क्या करती है?",
        a: "ALBL एक ब्रांड, मार्केटिंग और सेल्स ग्रोथ पार्टनर है — ब्रांड स्ट्रैटेजी, रिटेल और ट्रेड मार्केटिंग, डिजिटल मार्केटिंग, कस्टमर एक्विज़िशन, लोकल SEO और सेल्स-फ़ोकस्ड मार्केटिंग में बिज़नेस की मदद करती है।",
    },
    {
        q: "क्या ALBL नर्मदापुरम के बिज़नेस के साथ काम करती है?",
        a: "हाँ। नर्मदापुरम ALBL का मुख्य बाज़ार है — इतारसी और आसपास के इलाकों के साथ।",
    },
    {
        q: "क्या ALBL छोटे और लोकल बिज़नेस के साथ काम करती है?",
        a: "हाँ। ALBL प्रोफ़ेशनल ब्रांड और सेल्स-मार्केटिंग सोच को महत्वाकांक्षी लोकल और बढ़ते बिज़नेस तक पहुँचाती है।",
    },
    {
        q: "क्या ALBL सेल्स बढ़ाने में मदद कर सकती है?",
        a: "ALBL कस्टमर एक्विज़िशन, enquiries, विज़िबिलिटी, कन्वर्ज़न और सेल्स ग्रोथ जैसे बिज़नेस लक्ष्यों के इर्द-गिर्द मार्केटिंग स्ट्रैटेजी बनाती है। नतीजे बिज़नेस, बाज़ार, ऑफर और एक्ज़ीक्यूशन पर निर्भर करते हैं।",
    },
];

export const HiFinalCta = () => (
    <section className="bg-[#0D131F] hero-grid text-white" data-testid="hi-final-cta-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
            <Reveal>
                <Eyebrow dark>ALBL से बात करें</Eyebrow>
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.15] mt-5 max-w-3xl">
                    आपके बिज़नेस को किसी और मार्केटिंग एजेंसी से बेहतर मिलना चाहिए।
                </h2>
                <p className="mt-6 text-slate-400 text-base sm:text-lg max-w-2xl leading-relaxed">
                    बताइए आपका बिज़नेस आज कहाँ खड़ा है — हम दिखाएँगे कि आपकी मार्केटिंग कहाँ ग्रोथ छोड़ रही है।
                </p>
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <Link
                        to="/hi/contact"
                        data-testid="hi-final-cta-talk-button"
                        className="btn-sharp bg-[#C5A059] text-[#0D131F] text-xs font-bold tracking-[0.15em] uppercase px-8 py-4"
                    >
                        ALBL से बात करें
                    </Link>
                    <a
                        href={SITE.whatsappPrefill}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="hi-final-cta-whatsapp-button"
                        className="btn-sharp flex items-center gap-2 border border-white/25 text-white text-xs font-bold tracking-[0.15em] uppercase px-8 py-4 hover:border-[#25D366] hover:text-[#25D366]"
                    >
                        <MessageCircle className="h-4 w-4" /> WhatsApp
                    </a>
                </div>
                <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-sm text-slate-400">
                    <a href={SITE.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors" data-testid="hi-final-cta-phone">
                        <Phone className="h-4 w-4 text-[#C5A059]" /> {SITE.phone}
                    </a>
                    <a href={SITE.emailHref} className="flex items-center gap-2 hover:text-white transition-colors" data-testid="hi-final-cta-email">
                        <Mail className="h-4 w-4 text-[#C5A059]" /> {SITE.email}
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);

const HindiHome = () => {
    useEffect(() => {
        document.title = "ALBL Communications | नर्मदापुरम की ब्रांड और सेल्स ग्रोथ एजेंसी";
    }, []);

    return (
        <main lang="hi">
            {/* HERO */}
            <section className="bg-[#0D131F] hero-grid text-white pt-32 sm:pt-44 pb-20 sm:pb-28">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 grid lg:grid-cols-12 gap-14 items-center">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <Eyebrow dark>ब्रांड. मार्केटिंग. सेल्स. ग्रोथ.</Eyebrow>
                            <h1
                                className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.15] mt-6"
                                data-testid="hi-hero-heading"
                            >
                                हम सिर्फ़ बिज़नेस की मार्केटिंग नहीं करते।
                                <span className="block mt-2 text-[#C5A059]">
                                    हम ऐसे बिज़नेस बनाते हैं जो बिकते हैं।
                                </span>
                            </h1>
                            <p className="mt-6 font-serif-accent italic text-lg sm:text-xl text-slate-300" data-testid="hi-hero-subheading">
                                बड़े ब्रांडों वाली मार्केटिंग सोच — महत्वाकांक्षी बिज़नेस के लिए।
                            </p>
                            <p className="mt-4 text-sm sm:text-base text-slate-400 tracking-wide">
                                ब्रांड स्ट्रैटेजी. मार्केट एक्ज़ीक्यूशन. डिजिटल ग्रोथ. कस्टमर एक्विज़िशन. सेल्स-फ़ोकस्ड मार्केटिंग.
                            </p>
                            <div className="mt-10 flex flex-wrap gap-4">
                                <Link
                                    to="/hi/contact"
                                    data-testid="hi-hero-cta-talk-button"
                                    className="btn-sharp bg-white text-[#0D131F] text-xs font-bold tracking-[0.15em] uppercase px-8 py-4"
                                >
                                    ALBL से बात करें
                                </Link>
                                <Link
                                    to="/hi/contact?intent=audit"
                                    data-testid="hi-hero-cta-audit-button"
                                    className="btn-sharp border border-[#C5A059] text-[#C5A059] text-xs font-bold tracking-[0.15em] uppercase px-8 py-4 hover:bg-[#C5A059] hover:text-[#0D131F]"
                                >
                                    ग्रोथ ऑडिट लें
                                </Link>
                                <a
                                    href={SITE.whatsappPrefill}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="hi-hero-whatsapp-button"
                                    className="btn-sharp flex items-center gap-2 bg-[#25D366] text-[#0D131F] text-xs font-bold tracking-[0.15em] uppercase px-8 py-4"
                                >
                                    <MessageCircle className="h-4 w-4" /> WhatsApp
                                </a>
                            </div>
                            <a
                                href={SITE.phoneHref}
                                className="mt-8 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors"
                                data-testid="hi-hero-phone-link"
                            >
                                <Phone className="h-4 w-4 text-[#C5A059]" /> कॉल करें {SITE.phone}
                            </a>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5">
                        <Reveal delay={150}>
                            <div className="border border-white/10 bg-white/[0.03] backdrop-blur-sm p-8 sm:p-10">
                                <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#C5A059]">
                                    हम बिज़नेस से शुरुआत करते हैं
                                </p>
                                <ul className="mt-6 space-y-5">
                                    {HI_QUESTIONS.map((q, i) => (
                                        <li key={q} className="flex gap-4 items-baseline">
                                            <span className="font-serif-accent italic text-[#C5A059] text-lg shrink-0">
                                                0{i + 1}
                                            </span>
                                            <span className="text-slate-200 text-sm sm:text-base">{q}</span>
                                        </li>
                                    ))}
                                </ul>
                                <p className="mt-8 pt-6 border-t border-white/10 text-sm text-slate-400 leading-relaxed">
                                    फिर हम इन्हीं जवाबों के इर्द-गिर्द मार्केटिंग बनाते हैं।
                                </p>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            {/* FESTIVAL SEASON CAMPAIGN */}
            <FestivalBanner lang="hi" />

            {/* DIFFERENTIATION */}
            <section className="bg-[#F8FAFC]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <Eyebrow>फ़र्क़ क्या है</Eyebrow>
                            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.15] mt-5" data-testid="hi-differentiation-heading">
                                आपको एक और मार्केटिंग एजेंसी नहीं चाहिए।
                            </h2>
                            <div className="gold-rule mt-8" />
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <Reveal delay={120}>
                            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
                                ज़्यादातर एजेंसियां आपको पोस्ट, रील्स, वेबसाइट और &quot;डिजिटल मार्केटिंग&quot; बेचती हैं।
                            </p>
                            <p className="mt-4 text-slate-900 text-base sm:text-lg font-medium leading-relaxed">
                                ALBL की शुरुआत कहीं और से होती है।
                            </p>
                            <div className="mt-8 grid sm:grid-cols-2 gap-3">
                                {HI_QUESTIONS.map((q) => (
                                    <div key={q} className="border border-slate-200 bg-white px-5 py-4 text-sm text-slate-700">
                                        {q}
                                    </div>
                                ))}
                            </div>
                            <p className="mt-8 text-slate-600 text-base sm:text-lg leading-relaxed">
                                पहले हम इन सवालों के जवाब ढूंढते हैं।{" "}
                                <span className="text-slate-900 font-semibold">
                                    फिर बिज़नेस के अनुसार मार्केटिंग बनाते हैं।
                                </span>
                            </p>
                        </Reveal>
                    </div>
                </div>
            </section>

            {/* BIG-BRAND EXPERIENCE */}
            <section className="bg-[#0D131F] text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
                    <Reveal>
                        <Eyebrow dark>अनुभव</Eyebrow>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.15] mt-5 max-w-3xl" data-testid="hi-credentials-heading">
                            बड़े ब्रांड्स का अनुभव.
                            <span className="block text-[#C5A059]">लोकल मार्केट की समझ.</span>
                        </h2>
                    </Reveal>
                    <div className="mt-14 grid lg:grid-cols-12 gap-12">
                        <div className="lg:col-span-7">
                            <Reveal delay={100}>
                                <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
                                    ALBL की नींव <span className="text-white font-semibold">LG, Haier और Bisleri</span> जैसे बड़े ब्रांड्स के साथ प्रोफ़ेशनल ब्रांड-मार्केटिंग अनुभव पर टिकी है।
                                </p>
                                <p className="mt-5 text-slate-400 text-base leading-relaxed">
                                    हम जानते हैं कि एक गंभीर ब्रांड के पीछे क्या होता है — कैंपेन स्ट्रैटेजी और कंज़्यूमर कम्युनिकेशन से लेकर रिटेल विज़िबिलिटी, ट्रेड मार्केटिंग, डिजिटल कैंपेन और मार्केट एक्ज़ीक्यूशन तक।
                                </p>
                                <p className="mt-5 text-slate-300 text-base sm:text-lg leading-relaxed">
                                    अब हम वही सोच नर्मदापुरम, इतारसी और आसपास के बाज़ारों के महत्वाकांक्षी बिज़नेस तक पहुँचा रहे हैं।
                                </p>
                            </Reveal>
                        </div>
                        <div className="lg:col-span-5">
                            <Reveal delay={200}>
                                <div className="grid grid-cols-3 gap-3">
                                    {["LG", "Haier", "Bisleri"].map((b) => (
                                        <div key={b} className="border border-white/10 bg-white/[0.03] py-8 flex items-center justify-center font-display text-2xl font-bold tracking-widest text-slate-200">
                                            {b}
                                        </div>
                                    ))}
                                </div>
                                <p className="mt-5 text-xs text-slate-500 leading-relaxed">
                                    ब्रांड नाम केवल प्रोफ़ेशनल ब्रांड-मार्केटिंग अनुभव दर्शाते हैं। ALBL इन कंपनियों का आधिकारिक पार्टनर, प्रतिनिधि या एजेंसी नहीं है।
                                </p>
                            </Reveal>
                        </div>
                    </div>
                </div>
            </section>

            {/* SERVICES */}
            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
                    <Reveal>
                        <Eyebrow>हम क्या करते हैं</Eyebrow>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.15] mt-5" data-testid="hi-services-heading">
                            ब्रांड थिंकिंग से लेकर सेल्स एक्ज़ीक्यूशन तक।
                        </h2>
                    </Reveal>
                    <div className="mt-14 grid gap-px bg-slate-200 border border-slate-200">
                        {HI_SERVICES.map((s, i) => (
                            <Reveal key={s.num} delay={i * 60}>
                                <div className="grid sm:grid-cols-12 gap-4 sm:gap-8 items-baseline bg-white px-6 sm:px-10 py-8" data-testid={`hi-service-card-${i + 1}`}>
                                    <span className="font-serif-accent italic text-2xl text-[#C5A059] sm:col-span-1">{s.num}</span>
                                    <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900 tracking-tight sm:col-span-4">{s.title}</h3>
                                    <p className="text-slate-600 text-sm sm:text-base leading-relaxed sm:col-span-7">{s.text}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* DON'T / DO */}
            <section className="bg-[#0D131F] text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 grid lg:grid-cols-2 gap-14">
                    <Reveal>
                        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.15]" data-testid="hi-do-dont-heading">
                            हम क्या नहीं करते।
                        </h2>
                        <ul className="mt-10 space-y-5">
                            {HI_DONT.map((item) => (
                                <li key={item} className="flex gap-4 items-start">
                                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center border border-red-400/50">
                                        <X className="h-3 w-3 text-red-400" />
                                    </span>
                                    <span className="text-slate-300 text-sm sm:text-base">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                    <Reveal delay={150}>
                        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.15] text-[#C5A059]">
                            हम क्या करते हैं।
                        </h2>
                        <ul className="mt-10 space-y-5">
                            {HI_DO.map((item) => (
                                <li key={item} className="flex gap-4 items-start">
                                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center border border-[#C5A059]/60">
                                        <Check className="h-3 w-3 text-[#C5A059]" />
                                    </span>
                                    <span className="text-slate-200 text-sm sm:text-base">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </section>

            {/* MARKETS */}
            <section className="bg-[#F8FAFC]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
                    <Reveal>
                        <Eyebrow>हमारे बाज़ार</Eyebrow>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.15] mt-5" data-testid="hi-markets-heading">
                            लोकल से शुरुआत. <span className="text-[#C5A059]">बड़ी सोच.</span>
                        </h2>
                        <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed max-w-2xl">
                            ALBL नर्मदापुरम, इतारसी और आसपास के मध्य प्रदेश के बाज़ारों के बिज़नेस के साथ काम करती है।
                        </p>
                    </Reveal>
                    <Reveal delay={120}>
                        <div className="mt-12 flex flex-wrap gap-3">
                            {HI_MARKETS.map((m, i) => (
                                <span
                                    key={m}
                                    className={`px-5 py-3 text-sm tracking-wide border ${
                                        m === "नर्मदापुरम" || m === "इतारसी"
                                            ? "border-[#C5A059] text-[#8a6c33] font-semibold bg-white"
                                            : "border-slate-300 text-slate-700 bg-white"
                                    }`}
                                >
                                    {m}
                                </span>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </section>

            {/* PROCESS */}
            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
                    <Reveal>
                        <Eyebrow>हम कैसे काम करते हैं</Eyebrow>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.15] mt-5" data-testid="hi-process-heading">
                            कोई कॉपी-पेस्ट मार्केटिंग नहीं।
                        </h2>
                    </Reveal>
                    <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
                        {HI_PROCESS.map((p, i) => (
                            <Reveal key={p.num} delay={i * 80}>
                                <div className="bg-white p-8 h-full" data-testid={`hi-process-step-${i + 1}`}>
                                    <span className="font-serif-accent italic text-3xl text-[#C5A059]">{p.num}</span>
                                    <h3 className="font-display text-xl font-bold text-slate-900 tracking-tight mt-4">{p.title}</h3>
                                    <p className="mt-3 text-sm text-slate-600 leading-relaxed">{p.text}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* WHY ALBL EXISTS */}
            <section className="bg-[#F8FAFC]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <Eyebrow>ALBL के बारे में</Eyebrow>
                            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.15] mt-5">
                                ALBL क्यों बना।
                            </h2>
                            <div className="gold-rule mt-8" />
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <Reveal delay={120}>
                            <p className="font-serif-accent italic text-xl sm:text-2xl text-slate-800 leading-relaxed">
                                लोकल बिज़नेस को महंगी कॉर्पोरेट एजेंसियों और साधारण डिजिटल मार्केटिंग पैकेजों के बीच चुनने की मजबूरी नहीं होनी चाहिए।
                            </p>
                            <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed">
                                उन्हें गंभीर मार्केटिंग सोच मिलनी चाहिए — उनके बाज़ार, उनके ग्राहकों और उनके बिज़नेस की हक़ीक़त के अनुसार।
                            </p>
                            <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
                                LG, Haier और Bisleri जैसे ब्रांड्स के प्रोफ़ेशनल अनुभव के साथ, ALBL बढ़ने की इच्छा रखने वाले बिज़नेस तक व्यवस्थित ब्रांड-मार्केटिंग सोच पहुँचाती है।
                            </p>
                        </Reveal>
                    </div>
                </div>
            </section>

            {/* FAQ */}
            <section className="bg-white">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
                    <Reveal>
                        <Eyebrow>सवाल-जवाब</Eyebrow>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.15] mt-5" data-testid="hi-faq-heading">
                            अक्सर पूछे जाने वाले सवाल।
                        </h2>
                    </Reveal>
                    <Reveal delay={120}>
                        <Accordion type="single" collapsible className="mt-12">
                            {HI_FAQS.map((f, i) => (
                                <AccordionItem key={f.q} value={`hifaq-${i}`} data-testid={`hi-faq-item-${i + 1}`}>
                                    <AccordionTrigger className="text-left font-display text-base sm:text-lg font-semibold text-slate-900 hover:text-[#1E3A8A]" data-testid={`hi-faq-trigger-${i + 1}`}>
                                        {f.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-slate-600 text-sm sm:text-base leading-relaxed">
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </Reveal>
                </div>
            </section>

            <HiFinalCta />
        </main>
    );
};

export default HindiHome;
